import eyeOn from "../../assests/images/view.png";
import eyeOff from "../../assests/images/hide.png";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { registerService, googleAuth } from "../../services/auth";
import { LoginSocialGoogle } from "reactjs-social-login";
import { registerValid } from "../../validation/auth";
import isEmpty from "../../lib/isEmpty";
import { setAuthorization } from "../../config/axios";
import { GetCountries } from "react-country-state-city/dist/cjs";
import logostart from "../../assests/images/logostart.png";
import { useNavigate } from "react-router-dom";
import loginimage from "../../assests/images/Loginimage.png";
import { toastError, toastSuccess } from "../../config/ToastModal";
import { userResponse } from "../../features/authuser/Authuser";

const initialFormValue = {
  firstName: "",
  lastName: "",
  email: "",
  phoneNo: "",
  phoneStatus: false,
  password: "",
  confirmPassword: "",
};
const Register = () => {
  const dispatch = useDispatch();
  const routing = useNavigate();
  const [loading, setLoading] = useState(false);
  const [formValue, setFormValue] = useState(initialFormValue);
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const [isConPasswordVisible, setIsConPasswordVisible] = useState(false);
  const [errors, setErrors] = useState({});
  const [touched, setTouched] = useState({});
  const [countriesList, setCountriesList] = useState([]);

  const [activebtn, setActiveBtn] = useState("hr");

  const [checkterms, setCheckTerms] = useState(false);

  const {
    firstName,
    lastName,
    email,
    // jobTitle,
    // companyName,
    // country,
    // typesOfService,
    phoneNo,
    password,
    confirmPassword,
    // manPowerRequirement,
    phoneStatus,
    // manPower,
  } = formValue;

  const handleChange = ({ target: { name, value } }) => {
    setFormValue({ ...formValue, [name]: value });
  };

  const handleBlur = ({ target: { name, value } }) => {
    setTouched({ ...touched, [name]: true });
  };

  const togglePasswordVisibility = () => {
    setIsPasswordVisible(!isPasswordVisible);
  };
  const toggleConPasswordVisibility = () => {
    setIsConPasswordVisible(!isConPasswordVisible);
  };

  const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  const handleSumbitData = async (e) => {
    e.preventDefault();
    try {
      const data = { ...formValue, assignedCategory: activebtn };

      console.log(data, "data");
      if (!isEmpty(errors)) {
        toastError("Please fix the errors before submitting.");
        return;
      }
      if (!email || !/^[\w.%+-]+@[\w.-]+\.[a-zA-Z]{2,}$/.test(email)) {
        toastError("Please enter a valid email address.");
        return;
      }
      if (checkterms) {
        const response = await registerService(data);
        if (response.status === "OTP_STATUS") {
          dispatch(userResponse({ ...data, phoneStatus: false }));
          toastSuccess(response.message);
          routing("/otp");
        } else {
          for (let [c, d] of Object.entries(response?.errors)) {
            toastError(d);
          }
        }
      } else {
        toastError(
          "Please click to agree to our Privacy Policy and Terms & Conditions before continuing."
        );
      }
    } catch (err) {
      toastError("An unexpected error occurred. Please try again later.");
    }
  };

  const handleResolve = async (data) => {
    setLoading(true);
    try {
      if (data) {
        const datas = {
          name: data?.name,
          email: data?.email,
          profile: data?.picture,
          subId: data?.sub,
          // assignedCategory: activebtn,
        };
        const response = await googleAuth(datas);
        if (response?.status === true) {
          setAuthorization(response?.token);
          toastSuccess(response?.message);
          setTimeout(() => {
            routing("/dashboard");
            setLoading(false);
          }, 600);
        }
      }
    } catch (error) {
      setLoading(false);
    }
  };

  useEffect(() => {
    const checkValidation = registerValid(formValue);
    if (!checkValidation.status) {
      setErrors(checkValidation.errors);
    } else {
      setErrors({});
    }
  }, [formValue]);

  useEffect(() => {
    GetCountries().then((result) => {
      setCountriesList(result);
    });
  }, []);

  const termsPolicy = () => {
    window.open("https://hr.startuphirers.com/terms & conditions");
  };

  const backLogin = () => {
    routing("/");
  };

  const [checkpassword, setCheckPassword] = useState("");
  const [checkpasswordanother, setCheckPasswordanother] = useState(false);

  const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\W).{8,}$/;

  function validatePassword(passwords) {
    return passwordRegex.test(passwords);
  }
  useEffect(() => {
    if (password) {
      const status = validatePassword(password);
      if (status) {
        setCheckPassword(status);
        setCheckPasswordanother(false);
      } else {
        setCheckPassword(false);
      }
    }

    if (password?.length === 0) {
      setCheckPasswordanother(false);
    }
  }, [password]);
  return (
    <div className="login-section">
      <div
        className="image-layer"
        style={{
          padding: "40px",
          borderRight: "2px solid #f3f4f5",
        }}
      >
        <img src={loginimage} alt="no image" />
      </div>
      <div className="outer-box">
        {/* <!-- Login Form --> */}
        <div className="login-form default-form">
          <section className="form-inner">
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <img
                src={logostart}
                alt="no image"
                style={{
                  width: "70%",
                  // height:"20px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              />
            </div>
            <h2
              className="text-center mb-5 fw-bold"
              style={{ color: "#97144d", fontSize: "18px" }}
            >
              Recruiter-HR Account
            </h2>

            <div className="hr-button-sections">
              <div className="left-button">
                <button
                  className={
                    activebtn == "hr" ? "active-button-hr" : "button-hr"
                  }
                  onClick={() => setActiveBtn("hr")}
                >
                  Hr
                </button>
              </div>
              <div className="right-button">
                <button
                  className={
                    activebtn == "recruiter" ? "active-button-hr" : "button-hr"
                  }
                  onClick={() => setActiveBtn("recruiter")}
                >
                  Recuriter
                </button>
              </div>
            </div>
            <div className="row mt-4">
              <div className="col-md-6">
                <div className="form-group">
                  <label style={{ fontSize: "14px" }}>
                    First Name <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="First Name"
                    name="firstName"
                    value={firstName}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                  {touched?.firstName && (
                    <span className="text-danger">{errors?.firstName}</span>
                  )}
                </div>
              </div>

              <div className="col-md-6">
                <div className="form-group">
                  <label style={{ fontSize: "14px" }}>
                    Last Name <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Last Name"
                    name="lastName"
                    value={lastName}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                  {touched?.lastName && (
                    <span className="text-danger">{errors?.lastName}</span>
                  )}
                </div>
              </div>
            </div>

            <div className="row mt-4">
              <div className="col-md-6">
                <div className="form-group">
                  <label style={{ fontSize: "14px" }}>
                    Work Email ID <span className="text-danger">*</span>
                  </label>
                  <input
                    type="email"
                    name="email"
                    value={email}
                    onChange={handleChange}
                    placeholder="Work Email ID"
                    onBlur={handleBlur}
                  />
                  {touched?.email && (
                    <span className="text-danger">{errors?.email}</span>
                  )}
                </div>
              </div>

              <div className="col-md-6">
                <div className="form-group">
                  <label style={{ fontSize: "14px" }}>
                    Phone No <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    name="phoneNo"
                    value={phoneNo}
                    onChange={handleChange}
                    placeholder="Phone No"
                    onBlur={handleBlur}
                    onKeyPress={(e) => {
                      if (!/[0-9]/.test(e.key)) {
                        e.preventDefault();
                      }
                    }}
                    maxLength={10}
                  />
                  {touched?.phoneNo && (
                    <span className="text-danger">{errors?.phoneNo}</span>
                  )}
                </div>
              </div>
            </div>

            {/* <div className="row mt-4">
        <div className="col-md-6">
          <div className="form-group">
            <label>Job Title</label>
            <input
              type="text"
              name="jobTitle"
              value={jobTitle}
              onChange={handleChange}
              placeholder="Job Title"
              onBlur={handleBlur}
            />
            {touched?.jobTitle && (
              <span className="text-danger">{errors?.jobTitle}</span>
            )}
          </div>
        </div>

        <div className="col-md-6">
          <div className="form-group">
            <label>Company Name</label>
            <input
              type="text"
              name="companyName"
              value={companyName}
              onChange={handleChange}
              placeholder="Company Name"
              onBlur={handleBlur}
            />
            {touched?.companyName && (
              <span className="text-danger">{errors?.companyName}</span>
            )}
          </div>
        </div>
      </div> */}

            {/* <div className="row mt-4">
        <div className="col-md-6">
          <div className="form-group">
            <label>Country</label>
            <select
              name="country"
              onChange={handleChange}
              value={country}
              onBlur={handleBlur}
            >
              <option value="" disabled>
                Select country
              </option>
              {countriesList.map((item) => (
                <option key={item.id} value={item.name}>
                  {item.name}
                </option>
              ))}
            </select>
            {touched?.country && (
              <span className="text-danger">{errors.country}</span>
            )}
          </div>
        </div>

        <div className="col-md-6">
          <div className="form-group">
            <label>Type Of Service</label>
            <input
              type="text"
              name="typesOfService"
              value={typesOfService}
              onChange={handleChange}
              placeholder="Types Of Service"
              onBlur={handleBlur}
            />
            {touched?.typeOfService && (
              <span className="text-danger">{errors?.typeOfService}</span>
            )}
          </div>
        </div>
      </div> */}

            <div className="row mt-4">
              <div className="col-md-6">
                <div className="form-group">
                  <label style={{ fontSize: "14px" }}>
                    Password <span className="text-danger">*</span>
                  </label>
                  {/* <input
              type="password"
              name="password"
              value={password}
              onChange={handleChange}
              placeholder="Password"
              onBlur={handleBlur}
            />
            {touched?.password && (
              <span className="text-danger">{errors?.password}</span>
            )} */}
                  <div className="password-section">
                    <input
                      type={isPasswordVisible ? "text" : "password"}
                      name="password"
                      value={password}
                      onChange={handleChange}
                      placeholder="Password"
                      onBlur={handleBlur}
                      onClick={(e) => setCheckPasswordanother(true)}
                    />
                    <img
                      src={isPasswordVisible ? eyeOn : eyeOff}
                      className="password-icon"
                      alt="toggle password"
                      onClick={togglePasswordVisibility}
                      style={{ cursor: "pointer" }}
                    />
                  </div>
                  {touched?.password && (
                    <span className="text-danger">{errors?.password}</span>
                  )}
                </div>
              </div>

              <div className="col-md-6">
                <div className="form-group">
                  <label style={{ fontSize: "14px" }}>
                    Confirm Password <span className="text-danger">*</span>
                  </label>
                  {/* <input
              type="password"
              name="confirmPassword"
              value={confirmPassword}
              onChange={handleChange}
              placeholder="Confirm Password"
              onBlur={handleBlur}
            />
            {touched?.confirmPassword && (
              <span className="text-danger">{errors?.confirmPassword}</span>
            )} */}

                  <div className="password-section">
                    <input
                      type={isConPasswordVisible ? "text" : "password"}
                      name="confirmPassword"
                      value={confirmPassword}
                      onChange={handleChange}
                      placeholder="Confirm Password"
                      onBlur={handleBlur}
                    />
                    <img
                      src={isConPasswordVisible ? eyeOn : eyeOff}
                      className="password-icon"
                      alt="toggle password"
                      onClick={toggleConPasswordVisibility}
                      style={{ cursor: "pointer" }}
                    />
                  </div>

                  {touched?.confirmPassword && (
                    <span className="text-danger">
                      {errors?.confirmPassword}
                    </span>
                  )}
                </div>
              </div>
            </div>

            <div className="title text-danger mt-2 mb-2">
              {checkpasswordanother &&
                (checkpassword ? null : (
                  <>
                    Must be at least 8 characters with uppercase, lowercase, and
                    special characters.
                  </>
                ))}
            </div>

            <div
              className="mt-3 mb-2 d-flex  gap-2 align-items-center cursor"
              style={{ color: "#2874f0" }}
            >
              <div
                onClick={() => setCheckTerms(!checkterms)}
                className="cursor"
              >
                {checkterms ? (
                  <>
                    <input type="checkbox" checked={true} />
                  </>
                ) : (
                  <>
                    <input type="checkbox" checked={false} />
                  </>
                )}
              </div>
              <span onClick={termsPolicy} style={{ fontSize: "14px" }}>
                By continuing, you agree to our Privacy Policy and Terms &
                Conditions.
              </span>
            </div>
            {/* <div className="row mt-4">
        <div className="col-md-6">
          <div className="form-group">
            <label>ManPower Requirement</label>
            <input
              type="text"
              name="manPowerRequirement"
              value={manPowerRequirement}
              onChange={handleChange}
              placeholder="Manpower requirement"
              onBlur={handleBlur}
            />
            {touched?.manPowerRequirement && (
              <span className="text-danger">{errors?.manPowerRequirement}</span>
            )}
          </div>
        </div>

      </div> */}
            <div className="form-group mt-3">
              <button
                className="theme-btn btn-style-one"
                onClick={handleSumbitData}
                style={!isEmpty(errors) ? { cursor: "not-allowed" } : {}}
                disabled={!isEmpty(errors)}
              >
                Register Now
              </button>
            </div>
            <div className="text">
              Already have an account?{" "}
              <span
                onClick={backLogin}
                className="login"
                style={{ fontWeight: "500", cursor: "pointer" }}
              >
                Log In
              </span>
            </div>

            <div className="form-group mt-2 mb-0">
              <LoginSocialGoogle
                client_id={process.env.REACT_APP_API_GOOGLE_KEY}
                onLoginStart={handleResolve}
                scope="openid profile email"
                onResolve={({ provider, data }) => {
                  handleResolve(data);
                }}
                onReject={(err) => {}}
              >
                <div className="btn-box row">
                  <div
                    className="col-lg-12 col-md-12"
                    style={{ cursor: "pointer" }}
                  >
                    <div className="theme-btn social-btn-two google-btn">
                      <i className="fab fa-google"></i> {"Login in with Google"}
                    </div>
                  </div>
                </div>
              </LoginSocialGoogle>
            </div>

            {/* <div className="text-center">
        <div>or</div>
      </div> */}
            {/* <div className="form-group mt-2 mb-0">
        <LoginSocialGoogle
          client_id={process.env.NEXT_PUBLIC_API_GOOGLE_KEY}
          onLoginStart={handleResolve}
          scope="openid profile email"
          onResolve={({ provider, data }) => {
            handleResolve(data);
          }}
          onReject={(err) => {
          }}
        >
          <LoginWithSocial loading={loading} />
        </LoginSocialGoogle>
      </div> */}
          </section>
        </div>
      </div>
    </div>
  );
};

export default Register;
